// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/shop/" + {"18":"product","34":"category","220":"appointment","340":"helper","416":"promo","486":"comparsion","511":"cart","651":"googlemap","656":"feedback","809":"account","834":"partner"}[chunkId] + ".11652346.js";
};